import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { API_BASE_URL } from '../../../environments/environment';

export interface DialogData {
  // 物件コード
  cdSite: string;
  // 物件名
  siteName: string;
  // 代勤不可に登録した清掃員の、これからの代勤
  operations: any[];
}

/**
 * 代勤不可に登録した清掃員が、その物件でこれから代勤に入る予定の一覧
 * 利用者が内容を確認して、1件ずつ代勤を削除する
 */
@Component({
  selector: 'app-cannot-instead-operation-dialog',
  templateUrl: './cannot-instead-operation-dialog.component.html',
  styleUrls: ['./cannot-instead-operation-dialog.component.less']
})
export class CannotInsteadOperationDialogComponent implements OnInit {

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  // 物件名
  siteName = '';

  // これからの代勤
  operations = [];

  // 削除した件数
  deletedCount = 0;

  // 通信中
  nowLoading = false;

  constructor(
    private router: Router,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<CannotInsteadOperationDialogComponent>
  ) { }

  ngOnInit() {
    this.siteName = this.data.siteName;
    this.operations = this.data.operations || [];
  }

  /**
   * サインインが切れているときだけ最初の画面へ戻す
   * @param error エラー
   * @returns 最初の画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.dialogRef.close();
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  /**
   * 稼働管理のURLを作る（別のタブで開く）
   * ルート：operations/:hasHoliday/:start/:end/:staffCd
   * 期間はその代勤の日だけ、hasHoliday は「手配あり」を外す false 固定、清掃員コードは代勤者
   * @param op 代勤
   */
  operationUrl(op): string {
    return '#/operations/false/' + op.day + '/' + op.day + '/' + op.workInsteadStaffDailyCleaning;
  }

  /**
   * これからの代勤を取り直す
   * API: siteInfo/futureOperations
   */
  getData() {
    this.nowLoading = true;
    this.http.get(
      API_BASE_URL + '/api/v1/siteInfo/futureOperations?cdSite=' + encodeURIComponent(this.data.cdSite),
      {headers: this.headers}
    ).subscribe(res => {
      this.operations = res as any[];
      this.nowLoading = false;
    },
    error => {
      this.nowLoading = false;
      if (this.isSignOut(error)) return;
      alert("代勤の一覧を取得できませんでした。");
    });
  }

  /**
   * 代勤削除ボタンイベント
   * API: siteInfo/deleteOperation
   * @param op 代勤
   */
  deleteOperation(op) {
    const text = op.dayText + ' ' + op.startTime + '～' + op.endTime + ' ' + op.workInstead + ' さん';
    if (!window.confirm(text + '\nこの代勤を削除します。よろしいですか？')) return;

    this.nowLoading = true;
    this.http.post(
      API_BASE_URL + '/api/v1/siteInfo/deleteOperation?id=' + op.id
      + '&cdSite=' + encodeURIComponent(this.data.cdSite)
      + '&siteName=' + encodeURIComponent(this.siteName),
      {},
      {headers: this.headers}
    ).subscribe(res => {
      if (res) {
        this.deletedCount++;
      } else {
        alert('この代勤は削除できませんでした。\nすでに削除されているか、開始時間を過ぎています。一覧を取り直します。');
      }
      this.getData();
    },
    error => {
      this.nowLoading = false;
      if (this.isSignOut(error)) return;
      alert("代勤を削除できませんでした。");
    });
  }

  /**
   * 閉じるボタンイベント
   */
  close() {
    this.dialogRef.close();
  }
}
